import { ApiRequest, ApiResponse } from 'services/providers/dapv.types';
import { dapvApi } from 'services/providers/dapv';
import { StatisticsData } from 'services/statistic/statistic.types';

const appointmentApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getStatisticsData: build.mutation<ApiResponse<StatisticsData>, ApiRequest<{ year?: number } | undefined>>({
            query: (body) => ({
                url: `/app/stats/data${body?.year ? `?year=${body.year}` : ''}`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<StatisticsData>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
    })
});

export const { useGetStatisticsDataMutation } = appointmentApi;
